import React from 'react';

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { InfoCircle } from 'iconsax-react';

import TikIcon from 'assets/icons/tik-square-2.svg';

import classes from './CompareSection.module.scss';

const CompareSection = () => {

    const LightTooltip = styled(({ className, ...props }) => (
        <Tooltip placement='right-end' {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.white,
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow: theme.shadows[1],
            fontSize: 16,
            padding: 15,

        },
    }));

    return (
        <div className='container'>
            <div className="row d-md-flex d-none justify-content-center">
                <div className='col-12 col-xl-10 py-5'>
                    <table className={classes['tabl-comapre']}>
                        <thead>
                            <tr>
                                <td><h1>Compare plans</h1></td>
                                <td><h2>Free</h2></td>
                                <td><h2>Pharmuni Premium</h2></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    Access Course Library
                                    <LightTooltip
                                        title="Access specialized courses designed by Experts to meet the unique needs of the pharmaceutical industry">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    Free Courses only
                                </td>
                                <td>
                                    All Courses
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    CV Builder
                                    <LightTooltip
                                        title="Create a standout resume with our CV Builder, effortlessly highlighting your skills and achievements for a professional edge.">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    -
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Cover Letter Builder
                                    <LightTooltip
                                        title="Create a persuasive cover letter with our Cover Letter Builder, effortlessly highlighting your strengths and passion for the position. ">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    -
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Skill Tree
                                    <LightTooltip
                                        title="Visualize Your Progress. See how each completed course contributes to your overall skillset and identify areas for further growth.">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    Limited
                                </td>
                                <td>
                                    Unlimited
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Certifications
                                    <LightTooltip
                                        title="Earn shareable certificate of completion to demonstrate your newly acquired skills. ">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    For free courses
                                </td>
                                <td>
                                    All Courses
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    CV Optimization
                                    <LightTooltip
                                        title="Pro members are invited to exclusive group sessions for expert CV optimization. ">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    -
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Downloadable Resources
                                    <LightTooltip
                                        title="Access extra resources designed to support your learning and career growth. ">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    For free courses
                                </td>
                                <td>
                                    All Courses
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Learn on mobile
                                    <LightTooltip
                                        title="Learn on the go with our intuitive mobile app, available on iOS and Android, giving you the freedom to study anytime, anywhere. ">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Personalized Profile URL
                                    <LightTooltip
                                        title="Get a personalized profile URL and build your brand as you advance your career. ">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    -
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Explore Job Board
                                    <LightTooltip
                                        title="Explore the job board to discover exciting career opportunities and find your perfect match effortlessly. ">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Apply for Jobs
                                    <LightTooltip
                                        title="Apply for jobs seamlessly with our streamlined application process, bringing you closer to your dream career. ">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    -
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    VIP Job and Career Consultation
                                    <LightTooltip
                                        title="Our Pro members are entitled to a quarterly 30-minute career consultation with our experts. ">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    -
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Member-only Events
                                    <LightTooltip
                                        title="We invite our Pro members to exclusive events, such best practice workshops, Industry insights, software trends and more. ">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    -
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    LinkedIn Community
                                    <LightTooltip
                                        title="Gain access to a thriving community of Pharma experts from around the world to network, ask questions, and provide feedback. ">
                                        <InfoCircle size={18} color='#a6a5a3' />
                                    </LightTooltip>
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                                <td>
                                    <TikIcon />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default CompareSection;